/*global define: false */

define('validatePassword',['jquery', 'validate', 'unobtrusive'], function ($) {
    'use strict';

    var tests = {
            pwdLength: /^.{8,}$/,
            pwdCase: /((?=.*[a-z])(?=.*[A-Z]))/,
            pwdNumberSymbol: /[^a-zA-Z]/
        },
        successClass = 'pwd-pass-check',
        failClass = 'pwd-fail-check';

    function validatePassword(password, showErrors) {
        var isValid = true, result, test, testName;
        
        for (testName in tests) {
            if (tests.hasOwnProperty(testName)) {
                test = tests[testName];

                if (test instanceof RegExp) {
                    result = test.test(password);
                } else if ($.isFunction(test)) {
                    result = test(password);
                }

                $('[data-validation="' + testName + '"]')
                    .toggleClass(successClass, result)
                    .toggleClass(failClass, showErrors && !result);

                isValid = isValid && result;
            }
        }

        return isValid;
    }

    function escapeAttributeValue(value) {
        // As mentioned on http://api.jquery.com/category/selectors/
        return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, '\\$1');
    }

    function getModelPrefix(fieldName) {
        return fieldName.substr(0, fieldName.lastIndexOf('.') + 1);
    }

    function appendModelPrefix(value, prefix) {
        if (value.indexOf('*.') === 0) {
            value = value.replace('*.', prefix);
        }
        return value;
    }

    // The desired design is that:
    // #1 - the first time the user tyes in the password field, the rules
    //      that pass should turn green, but rules that don't pass should stay
    //      greyed out. the input field should stay as-is w/ a grey border.
    // #2 - on blur, or on subsequent edits, rules that don't pass should turn
    //      red, the input field should have a red border, and the "password is not
    //      strong enough error" should be displayed
    // Therefore we can't use the default keyup validation functionality alone. We can rely on 
    // the default blur behavior to handle #2. To accomplish #1, we attach our own keyup event
    // validation and tell validatePassword() not to show errors (2nd parameter). This works
    // because when validatePassword() is called from the $.validator natively, it passes a DOM 
    // element as the 2nd parameter which is "truthy".
    $('[data-val-strongpassword]').on('keyup', function () {
        validatePassword(this.value, false);
    });

    $.validator.unobtrusive.adapters.add('strongpassword', ['emailid', 'email'], function (options) {
        // find the DOM element for the emailid field. uses same logic that MS uses in unobtrusive library
        // to find and append ModelPrefix to the field name. unfortunately the MS functions aren't publicly
        // exposed, so they are copy/pasted above (luckily they are small).
        var prefix = getModelPrefix(options.element.name),
            other = options.params.emailid,
            fullOtherName = appendModelPrefix(other, prefix),
            element = $(options.form).find(':input').filter('[name="' + escapeAttributeValue(fullOtherName) + '"]')[0];

        // wire up notEqualTo validator first, so it runs first (only 1 validator is shown at a time)
        options.rules.notEqualTo = element;
        options.messages.notEqualTo = options.params.email;

        options.rules.strongPassword = true;
        options.messages.strongPassword = options.message;
    });

    $.validator.addMethod('strongPassword', validatePassword);

    $.validator.addMethod('notEqualTo', function (value, element, param) {
        return value && param && value.toLowerCase() !== param.value.toLowerCase();
    });
});
